import { useState } from "react"

const useStripeInfo = () => {
  const [stripeInfo, _setStripeInfo] = useState(window.stripeInfo)

  return stripeInfo
}

export default useStripeInfo
